import { render } from "./ExternalAdmin.vue?vue&type=template&id=45ea7af1"
import script from "./ExternalAdmin.vue?vue&type=script&lang=js"
export * from "./ExternalAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__